import { render, staticRenderFns } from "./bike.vue?vue&type=template&id=71f48586&scoped=true&lang=pug&"
import script from "./bike.vue?vue&type=script&lang=js&"
export * from "./bike.vue?vue&type=script&lang=js&"
import style0 from "./bike.vue?vue&type=style&index=0&id=71f48586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f48586",
  null
  
)

export default component.exports